import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BlogPost } from '../interfaces/blog-post';

@Injectable({
  providedIn: 'root'
})
export class BlogApiService {

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
  }

  postBlogPost(blogPost: BlogPost) {
    return this.httpClient.post(this.baseUrl + 'blogposts/', blogPost);
  }

  getBlogPosts() {
    return this.httpClient.get(this.baseUrl + 'blogposts');
  }

  getBlogPost(id: string) {
    return this.httpClient.get(this.baseUrl + 'blogposts/' + id);
  }
}
